"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/styles");
var _material = require("@mui/material");
var _InsertComment = _interopRequireDefault(require("@mui/icons-material/InsertComment"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CustomSelect = _interopRequireDefault(require("./CustomSelect"));
var _CustomDiamBranchingQuestion = _interopRequireDefault(require("./CustomDiamBranchingQuestion"));
var _lodash = require("lodash");
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _AddComment = _interopRequireDefault(require("../../../dist/components/dialogs/AddComment"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    centerText: {
      textAlign: 'center'
    }
  };
};
var CustomDiamQuestion = /*#__PURE__*/function (_Component) {
  function CustomDiamQuestion(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomDiamQuestion);
    _this = _callSuper(this, CustomDiamQuestion, [props]);
    var serviceList = props.serviceList,
      value = props.value,
      options = props.options;
    var rows = value ? value.map(function (v, index) {
      var a = JSON.parse(v);
      var rowValue = options.find(function (o) {
        return o.value == a.rowValue;
      });
      var services = a.services;
      var rowValueText = a.rowValueText;
      var rowOptions = options;
      return {
        id: index,
        value: rowValue ? rowValue : {
          label: '',
          value: ''
        },
        valueText: rowValueText,
        rowOptions: rowOptions,
        services: serviceList.map(function (h) {
          var svc = services.find(function (s) {
            return s.serviceID == h.value;
          });
          var d = {
            serviceID: h.value,
            checked: svc ? svc.checked : false,
            rowID: index,
            comment: svc ? svc.comment : '',
            disabled: false
          };
          return d;
        })
      };
    }) : [];
    if (rows.length === 0) {
      var row = {
        id: 0,
        value: {
          label: '',
          value: ''
        },
        valueText: '',
        rowOptions: options
      };
      row.services = serviceList.map(function (h) {
        var d = {
          serviceID: h.value,
          checked: false,
          rowID: row.id,
          comment: h.comment
        };
        return d;
      });
      rows.push(row);
    } else {
      var selectedServices = [];
      rows = rows.map(function (r) {
        r.rowOptions = _this.getRowOption(r.value, rows);
        r.services.forEach(function (s) {
          if (s.checked) {
            selectedServices.push({
              id: r.id,
              serviceID: s.serviceID
            });
          }
        });
        return r;
      });
      rows.forEach(function (row) {
        row.services.forEach(function (s) {
          s.disabled = selectedServices.findIndex(function (ss) {
            return ss.id !== row.id && ss.serviceID === s.serviceID;
          }) < 0 ? false : true;
        });
      });
    }
    _this.state = {
      showCommentDialog: false,
      clickedRowID: '',
      clickedServiceID: '',
      commentVal: '',
      branchingRows: {},
      rows: rows
    };
    ['updateRow', 'updateService', 'handleAddComment', 'updateText', 'getRowOption', 'setBranchingQuestions', 'onBranchingRowChange', 'convertToValue'].map(function (item) {
      return _this[item] = _this[item].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(CustomDiamQuestion, _Component);
  return (0, _createClass2["default"])(CustomDiamQuestion, [{
    key: "setBranchingQuestions",
    value: function setBranchingQuestions(questionID, serviceID, value) {
      var branchingRows = this.state.branchingRows;
      if (branchingRows[questionID] === undefined) {
        branchingRows[questionID] = {};
        branchingRows[questionID][serviceID] = value;
      } else {
        branchingRows[questionID][serviceID] = value;
      }
    }
  }, {
    key: "onBranchingRowChange",
    value: function onBranchingRowChange(questionID, serviceID, value) {
      var _this2 = this;
      var branchingRows = (0, _lodash.cloneDeep)(this.state.branchingRows);
      if (branchingRows[questionID] === undefined) {
        branchingRows[questionID] = {};
        branchingRows[questionID][serviceID] = value;
      } else {
        branchingRows[questionID][serviceID] = value;
      }
      this.setState({
        branchingRows: branchingRows
      }, function () {
        var val = _this2.convertToBranchingValue(branchingRows[questionID]);
        _this2.props.onBranchingQuestionChange([].concat(questionID), val);
      });
    }
  }, {
    key: "convertToBranchingValue",
    value: function convertToBranchingValue(branchingRow) {
      var values = [];
      Object.keys(branchingRow).forEach(function (serviceID) {
        var row = branchingRow[serviceID];
        var rowValue = row.value ? row.value.value : '';
        if ((rowValue !== '' || row.valueText !== '') && !values.find(function (v) {
          return v.value == rowValue && v.valueText == row.valueText;
        })) {
          values.push({
            value: rowValue,
            valueText: row.valueText
          });
        }
      });
      var value = values.map(function (v) {
        var services = Object.keys(branchingRow).reduce(function (all, serviceID) {
          var row = branchingRow[serviceID];
          var rowValue = row.value ? row.value.value : '';
          if (rowValue === v.value && row.valueText === v.valueText) {
            all.push({
              serviceID: serviceID,
              checked: true,
              comment: row.comment
            });
          }
          return all;
        }, []);
        return JSON.stringify({
          rowValue: v.value,
          rowValueText: v.valueText,
          services: services
        });
      });
      return value;
    }
  }, {
    key: "getRowOption",
    value: function getRowOption(value, rows) {
      var allOptions = this.props.options;
      var rowValues = [];
      rows.forEach(function (r) {
        var val = r.value && r.value !== '' ? r.value.value : '';
        rowValues.push(val);
      });
      var rowOptions = allOptions.reduce(function (all, o) {
        if (rowValues.findIndex(function (rv) {
          return rv == o.value;
        }) < 0 || value && o.value == value || value && o.value == value.value || o.value === '') {
          all.push(o);
        }
        return all;
      }, []);
      return rowOptions;
    }
  }, {
    key: "updateRow",
    value: function updateRow(id) {
      var _this3 = this;
      return function (event, value) {
        var rows = [].concat(_this3.state.rows);
        var row = rows.find(function (r) {
          return r.id === id;
        });
        row.value = value ? value : {
          label: '',
          value: ''
        };
        var selectedServices = [];
        rows.forEach(function (r) {
          if (r.id !== row.id) {
            r.services.forEach(function (rs) {
              if (rs.checked) {
                selectedServices.push(rs.serviceID);
              }
            });
          }
        });
        row.services.forEach(function (s) {
          s.disabled = selectedServices.indexOf(s.serviceID.toString()) < 0 ? false : true;
          s.checked = s.checked && (!value || !value.value) ? false : s.checked;
        });
        rows.forEach(function (r) {
          var _r$value;
          r.rowOptions = _this3.getRowOption((_r$value = r.value) === null || _r$value === void 0 ? void 0 : _r$value.value, rows);
        });
        _this3.setState({
          rows: rows
        });
        _this3.props.onChange(_this3.convertToValue(rows));
      };
    }
  }, {
    key: "updateText",
    value: function updateText(id) {
      var _this4 = this;
      return function (value) {
        var rows = [].concat(_this4.state.rows);
        var row = rows.find(function (r) {
          return r.id === id;
        });
        row.valueText = value.target.value;
        _this4.setState({
          rows: rows
        });
        _this4.props.onChange(_this4.convertToValue(rows));
      };
    }
  }, {
    key: "updateService",
    value: function updateService(id, serviceID) {
      var _this5 = this;
      return function (value) {
        var rows = [].concat(_this5.state.rows);
        var row = rows.find(function (r) {
          return r.id === id;
        });
        var service = row.services.find(function (d) {
          return d.serviceID == serviceID;
        });
        service.checked = value.target.checked;
        rows.forEach(function (r) {
          if (r.id !== id) {
            r.services.forEach(function (s) {
              if (s.serviceID === serviceID) {
                s.disabled = value.target.checked;
              }
            });
          }
        });
        _this5.setState({
          rows: rows
        });
        _this5.props.onChange(_this5.convertToValue(rows));
      };
    }
  }, {
    key: "addRow",
    value: function addRow() {
      var serviceList = this.props.serviceList;
      var rows = [].concat(this.state.rows);
      var rowOptions = this.getRowOption('', rows);
      var selectedServices = [];
      if (!this.props.useDropdown) {
        rows.forEach(function (r) {
          r.services.forEach(function (s) {
            if (s.checked) {
              selectedServices.push({
                id: r.id,
                serviceID: s.serviceID
              });
            }
          });
          return r;
        });
      }
      var maxID = Math.max.apply(Math, rows.map(function (r) {
        return r.id;
      }));
      var row = {
        id: maxID + 1,
        value: {
          label: '',
          value: ''
        },
        valueText: '',
        rowOptions: rowOptions
      };
      row.services = serviceList.map(function (h) {
        var d = {
          serviceID: h.value,
          checked: false,
          rowID: row.id,
          comment: ''
        };
        d.disabled = selectedServices.findIndex(function (ss) {
          return ss.id !== row.id && ss.serviceID === d.serviceID;
        }) < 0 ? false : true;
        return d;
      });
      rows.push(row);
      this.setState({
        rows: rows
      });
    }
  }, {
    key: "deleteRow",
    value: function deleteRow(id) {
      var _this6 = this;
      var rows = [].concat(this.state.rows);
      var newRows = rows.filter(function (r) {
        return r.id !== id;
      });
      var selectedServices = [];
      newRows.forEach(function (r) {
        var _r$value2;
        r.rowOptions = _this6.getRowOption((_r$value2 = r.value) === null || _r$value2 === void 0 ? void 0 : _r$value2.value, newRows);
        r.services.forEach(function (s) {
          if (s.checked) {
            selectedServices.push({
              id: r.id,
              serviceID: s.serviceID
            });
          }
        });
      });
      newRows.forEach(function (row) {
        row.services.forEach(function (s) {
          s.disabled = selectedServices.findIndex(function (ss) {
            return ss.id !== row.id && ss.serviceID === s.serviceID;
          }) < 0 ? false : true;
        });
      });
      this.setState({
        rows: newRows
      });

      //Convert the rows array into a string value that can be saved off to the survey
      this.props.onChange(this.convertToValue(newRows));
    }
  }, {
    key: "convertToValue",
    value: function convertToValue(rows) {
      //Convert to array or arrays for simplicity when saving the surey values
      var value = rows.map(function (r) {
        return JSON.stringify({
          rowValue: r.value ? r.value.value : '',
          rowValueText: r.valueText,
          services: r.services
        });
      });
      return value;
    }
  }, {
    key: "handleAddComment",
    value: function handleAddComment(value, rowID, serviceID) {
      //Add the comment value to Survey Answer as "service.comment":
      var rows = [].concat(this.state.rows);
      var row = rows.find(function (r) {
        return r.id === rowID;
      });
      var service = row.services.find(function (d) {
        return d.serviceID == serviceID;
      });
      service.comment = value;
      this.setState({
        rows: rows
      });
      this.props.onChange(this.convertToValue(rows));
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        options = _this$props.options,
        serviceList = _this$props.serviceList,
        branchingQuestions = _this$props.branchingQuestions,
        useDropdown = _this$props.useDropdown,
        questions = _this$props.questions,
        answers = _this$props.answers,
        questionData = _this$props.questionData,
        language = _this$props.language,
        parentQuestionNumbers = _this$props.parentQuestionNumbers;
      var _this$state = this.state,
        rows = _this$state.rows,
        showCommentDialog = _this$state.showCommentDialog;
      var disabled = rows.length == 1;
      return [/*#__PURE__*/_react["default"].createElement(_material.Table, {
        key: 'diamQuestions'
      }, /*#__PURE__*/_react["default"].createElement(_material.TableHead, null, /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
        style: {
          backgroundColor: '#fafafa'
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        padding: 'normal',
        style: {
          width: '20%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return _this7.addRow();
        }
      }, "Add")), serviceList.map(function (d) {
        return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.centerText,
          padding: 'normal',
          key: "service-label-".concat(d.value)
        }, d.label);
      }), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null))), /*#__PURE__*/_react["default"].createElement(_material.TableBody, null, rows.map(function (r) {
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: "row-container-".concat(r.id)
        }, /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
          key: r.id
        }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          padding: 'normal',
          key: "rowValue-".concat(r.id),
          style: {
            width: '20%'
          }
        }, useDropdown && /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          label: "",
          disabled: false,
          name: "rowValue",
          options: r.rowOptions,
          onChange: function onChange(value) {
            return _this7.updateRow(r.id, value);
          },
          value: r.value
        }), !useDropdown && /*#__PURE__*/_react["default"].createElement(_material.TextField, {
          label: "",
          name: "rowValueText",
          onBlur: _this7.updateText(r.id),
          defaultValue: r.valueText
        })), r.services.map(function (d) {
          return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
            className: classes.centerText,
            padding: 'normal',
            key: "service-".concat(d.serviceID)
          }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
            disabled: (!r.value || r.value === '' || r.value.value === '') && useDropdown || d.disabled,
            checked: d.checked,
            value: d.value,
            onChange: _this7.updateService(r.id, d.serviceID)
          }), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
            title: "Add Comment",
            "aria-label": "add"
          }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
            disabled: (!r.value || r.value === '' || r.value.value === '') && useDropdown || !useDropdown && r.valueText === '' || !d.checked || d.disabled,
            "aria-label": "Add Comment",
            onClick: function onClick() {
              return _this7.setState({
                showCommentDialog: true,
                commentVal: d.comment,
                clickedRowID: r.id,
                clickedServiceID: d.serviceID
              });
            }
          }, /*#__PURE__*/_react["default"].createElement(_InsertComment["default"], {
            color: d.comment !== '' && d.comment !== undefined ? 'primary' : 'inherit'
          }, d.comment)))));
        }), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, !disabled && /*#__PURE__*/_react["default"].createElement(_material.Button, {
          color: "primary",
          className: classes.button,
          onClick: function onClick() {
            return _this7.deleteRow(r.id);
          }
        }, "Delete"))), r.value && branchingQuestions[r.value.value] && branchingQuestions[r.value.value].map(function (sb, idx) {
          return /*#__PURE__*/_react["default"].createElement(_CustomDiamBranchingQuestion["default"], {
            parentQuestionNumbers: parentQuestionNumbers,
            questionNumber: idx,
            key: "".concat(r.value.value, "-").concat(sb),
            onBranchingQuestionChange: _this7.onBranchingRowChange,
            services: [].concat(r.services),
            classes: classes,
            questions: questions,
            answers: answers,
            questionData: questionData,
            questionID: sb,
            parentQuestionIDs: [_this7.props.questionID],
            language: language,
            setBranchingQuestions: _this7.setBranchingQuestions
          });
        }));
      }))), /*#__PURE__*/_react["default"].createElement(_AddComment["default"], {
        open: showCommentDialog,
        commentVal: this.state.commentVal,
        title: 'Add/Edit Comment',
        contentText: "(Limited to 100 characters)",
        onConfirm: function onConfirm(comment) {
          _this7.setState({
            showCommentDialog: false
          });
          _this7.handleAddComment(comment, _this7.state.clickedRowID, _this7.state.clickedServiceID);
        },
        onClose: function onClose() {
          return _this7.setState({
            showCommentDialog: false
          });
        },
        key: "diamComment"
      })];
    }
  }]);
}(_react.Component);
CustomDiamQuestion.propTypes = {
  value: _propTypes["default"].array,
  onChange: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomDiamQuestion);